<template>
  <a-drawer title="处方详情" placement="right" width="800" :closable="true" :visible="drawer.visible" @close="onCloseDrawer">
    <a-row>
      <a-col span="24">
        <a-card title="处方信息" size="small" :bordered="false">
          <a-row style="margin-left: 8px;">
            <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24" style="padding-left: 3px;">
              <a-row>
                <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">患者姓名:</span><span class="row-h-40">{{(undefined == record.name || null == record.name || '' == record.name)?'-':record.name}}</span></a-col>
                <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">性别:</span><span class="row-h-40">{{(undefined == record.sexName || null == record.sexName || '' == record.sexName)?'-':record.sexName}}</span></a-col>
                <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">联系电话:</span><span class="row-h-40">{{(undefined == record.phone || null == record.phone || '' == record.phone)?'-':record.phone}}</span></a-col>
              </a-row>
            </a-col>
          </a-row>
          <a-row style="margin-left: 8px;margin-bottom: 5px;">
            <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">处方单号:</span><span class="row-h-40">{{(undefined == record.code || null == record.code || '' == record.code)?'-':record.code}}</span></a-col>
            <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">就诊医院:</span><span class="row-h-40">{{(undefined == record.hospitalName || null == record.hospitalName || '' == record.hospitalName)?'-':record.hospitalName}}</span></a-col>
            <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">就诊科别:</span><span class="row-h-40">{{(undefined == record.department || null == record.department || '' == record.department)?'-':record.department}}</span></a-col>
          </a-row>
          <a-row style="margin-left: 8px;">
            <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">就诊日期:</span><span class="row-h-40">{{(undefined == record.recipeTime || null == record.recipeTime || '' == record.recipeTime)?'-':record.recipeTime}}</span></a-col>
            <a-col :sm="24" :xs="12" :md="16" :lg="16" :xl="16" :xxl="16"><span class="row-h-40">临床诊断:</span><span class="row-h-40">{{(undefined == record.diagnostic || null == record.diagnostic || '' == record.diagnostic)?'-':record.diagnostic}}</span></a-col>
          </a-row>
          <a-row style="margin-left: 8px;">
            <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24" class="b-border l-border r-border"
                   style="padding-left: 3px;min-height: 400px;">
              <a-row class="row-flex">
                <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24">
                  <a-row class="row-flex">
                    <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"
                           style="margin-left: 10px; padding-top: 3px; padding-bottom: 3px;font-weight: bold;">Rp.
                    </a-col>
                  </a-row>
                  <a-row v-if="record.type == 'SDP'">
                    <a-col style="padding-left: 20px;white-space:pre-wrap;word-wrap:break-word;overflow:hidden;padding-top: 3px; padding-bottom: 3px;" :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24">
                      {{ record.presName }}
                    </a-col>
                  </a-row>
                  <a-row v-else-if="record.type == 'CM'">
                    <template v-if="(record.drugs||[]).length> 1">
                      <template v-for="(item, index) in record.drugs">
                        <a-col :key="'d-' + (index+1)" style="padding-left: 20px;white-space:pre-wrap;word-wrap:break-word;overflow:hidden;padding-top: 3px; padding-bottom: 3px;" :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24">
                          {{ item.drugName }}{{ item.spec }}&nbsp;&nbsp;{{ item.dosage }}{{ item.unit }}<span v-if="(item.desc||'') != ''" style="margin-left: 5px;">,({{ item.desc }})</span>
                          <span v-if="(item.usage||'') != ''" style="margin-left: 5px;">,({{ item.usage }})</span>
                        </a-col>
                      </template>
                    </template>
                    <template v-else>
                      <template v-for="(item, index) in record.drugs">
                        <a-col :key="'d-' + (index+1)" style="padding-left: 20px;white-space:pre-wrap;word-wrap:break-word;overflow:hidden;padding-top: 3px; padding-bottom: 3px;" :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24">
                          {{ item.drugName }}{{ item.spec }}&nbsp;&nbsp;{{ item.dosage }}{{ item.unit }}<span v-if="(item.desc||'') != ''" style="margin-left: 5px;">,({{ item.desc }})</span>
                          <span v-if="(item.usage||'') != ''" style="margin-left: 5px;">,({{ item.usage }})</span>
                        </a-col>
                      </template>
                    </template>
                  </a-row>
                  <a-row v-else>
                    <a-col v-for="(item, index) in record.drugs" :key="'d-' + (index+1)" style="padding-left: 20px;white-space:nowrap;" :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24">
                      <div>{{ (index + 1) }}.&nbsp;{{ item.drugName }}&nbsp;&nbsp;{{ item.spec}}&nbsp;&nbsp;{{ item.salesQty }}{{ item.salesUnit }}
                      </div>
                      <div style="margin-left: 5px;">
                        用法:&nbsp;&nbsp;&nbsp;{{ item.usage }}&nbsp;&nbsp;&nbsp;{{ item.dosage }}{{ item.unit }}&nbsp;&nbsp;&nbsp;{{ item.frequency }}
                      </div>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col style="text-align: left; line-height: 24px;padding-left: 40px;margin-top: 12px;">
                      <span v-if="record.type == 'SDP'">{{ record.doses }}份{{ (record.usage || '') != '' ? ',' : '' }}&nbsp;</span>
                      <span v-else-if="record.type == 'CM'">{{ record.doses }}付{{ (record.usage || '') != '' ? ',' : '' }}&nbsp;</span>
                      {{ record.usage || '' }}
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <a-row style="margin-left: 8px;margin-bottom: 5px;">
            <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8">
              <span class="row-h-40">医师:</span><span class="row-h-40">{{(undefined == record.doctorName || null == record.doctorName || '' == record.doctorName)?'-':record.doctorName}}</span>
            </a-col>
            <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8">
              <span class="row-h-40">审核:</span><span class="row-h-40">&nbsp;</span>
            </a-col>
            <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8">
              <span class="row-h-40">金额:</span><span class="row-h-40">{{(undefined == record.roamAmount || null == record.roamAmount)?'-':('¥ '+ record.roamAmount.toFixed(2))}}</span>
            </a-col>
          </a-row>
        </a-card>
        <a-card title="取药信息" size="small" :bordered="false">
          <a-row style="margin-left: 8px;">
            <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">取药方式:</span><span class="row-h-40">{{(undefined == record.takeName || null == record.takeName || '' == record.takeName)?'-':record.takeName}}</span></a-col>
            <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">收件人姓名:</span><span class="row-h-40">{{(undefined == record.consigneeName || null == record.consigneeName || '' == record.consigneeName)?'-':record.consigneeName}}</span></a-col>
            <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">收件人电话:</span><span class="row-h-40">{{(undefined == record.consigneePhone || null == record.consigneePhone || '' == record.consigneePhone)?'-':record.consigneePhone}}</span></a-col>
          </a-row>
          <a-row style="margin-left: 8px;margin-bottom: 5px;">
            <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"><span class="row-h-40">收件地址:</span><span class="row-h-40">{{(undefined == record.address || null == record.address || '' == record.address)?'-':record.address}}</span></a-col>
          </a-row>
        </a-card>
        <a-card v-if="(undefined != record.delivery && null != record.delivery)" title="配送信息" size="small" :bordered="false">
          <a-row style="margin-left: 8px;">
            <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">配送方式:</span><span class="row-h-40">{{(undefined == record.delivery.model || null == record.delivery.model)?'-':(record.delivery.model=='HOME_DELIVERY'?'送货上门':'快递配送')}}</span></a-col>
            <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">{{(record.delivery.model=='HOME_DELIVERY'?'送货人':'快递单号')}}:</span><span class="row-h-40">{{(record.delivery.model=='HOME_DELIVERY'?((undefined == record.delivery.deliverer || null == record.delivery.deliverer)?'-':(record.delivery.deliverer + '(' + record.delivery.delivererPhone + ')')):((undefined == record.delivery.expressName || null == record.delivery.expressName)?'-':(record.delivery.expressNo + '(' + record.delivery.expressName + ')')))}}</span></a-col>
            <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">发货时间:</span><span class="row-h-40">{{(undefined == record.delivery.deliveryTime || null == record.delivery.deliveryTime || '' == record.delivery.deliveryTime)?'-':record.delivery.deliveryTime}}</span></a-col>
          </a-row>
        </a-card>
        <a-card v-if="record.status === 'Z_FINISHED'" title="确认信息" size="small" :bordered="false">
          <a-row style="margin-left: 8px;">
            <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">确认收货时间:</span><span class="row-h-40">{{ record.receiveTime }}</span></a-col>
            <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">&nbsp;</span></a-col>
            <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">&nbsp;</span></a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
  </a-drawer>
</template>

<script>
    export default {
      name: "Detail",
      data(){
        return {
          drawer:{
            visible:false
          },
          record:{}
        }
      },
      methods:{
        showDrawer:function (id) {
          const self = this;
          this.$axios.get('/api/clinic/roam/recipe/'+id).then(function (res) {
            if (res.msg.flag == 0) {
              if(null != res.biz){
                self.record = res.biz;
                self.drawer.visible=true;
              }else{
                self.record = {};
              }
            }else{
              self.$message.error(res.msg.message, 2);
            }
          }, function (res) {
          });
        },
        onCloseDrawer:function () {
          this.drawer.visible=false;
        }
      }
    }
</script>

<style scoped>
  .row-h-40 {
    height: 40px;
    line-height: 40px;
    margin-top: 8px;
    margin-bottom: 8px;
    padding-left: 4px;
    padding-right: 4px;
  }
</style>
